"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.generateRestHandlers = exports.withErrors = exports.getResponseStatusByErrorType = exports.createUrlBuilder = void 0;
var pluralize_1 = __importDefault(require("pluralize"));
var msw_1 = require("msw");
var OperationError_1 = require("../errors/OperationError");
function createUrlBuilder(baseUrl) {
    return function (path) {
        var url = new URL(path, baseUrl || 'http://localhost');
        return baseUrl ? url.toString() : url.pathname;
    };
}
exports.createUrlBuilder = createUrlBuilder;
function getResponseStatusByErrorType(error) {
    switch (error.type) {
        case OperationError_1.OperationErrorType.EntityNotFound:
            return 404;
        case OperationError_1.OperationErrorType.DuplicatePrimaryKey:
            return 409;
        default:
            return 500;
    }
}
exports.getResponseStatusByErrorType = getResponseStatusByErrorType;
function withErrors(handler) {
    return function (req, res, ctx) {
        try {
            return handler(req, res, ctx);
        }
        catch (error) {
            return res(ctx.status(getResponseStatusByErrorType(error)), ctx.json({
                message: error.message
            }));
        }
    };
}
exports.withErrors = withErrors;
function generateRestHandlers(modelName, primaryKey, model, baseUrl) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var modelPath = pluralize_1["default"](modelName);
    var buildUrl = createUrlBuilder(baseUrl);
    return [
        msw_1.rest.get(buildUrl(modelPath), withErrors(function (req, res, ctx) {
            var cursor = req.url.searchParams.get('cursor');
            var rawSkip = req.url.searchParams.get('skip');
            var rawTake = req.url.searchParams.get('take');
            var skip = parseInt(rawSkip !== null && rawSkip !== void 0 ? rawSkip : '0', 10);
            var take = rawTake == null ? rawTake : parseInt(rawTake, 10);
            var options = { where: {} };
            if (take && !isNaN(take) && !isNaN(skip)) {
                options = Object.assign(options, { take: take, skip: skip });
            }
            if (take && !isNaN(take) && cursor) {
                options = Object.assign(options, { take: take, cursor: cursor });
            }
            var records = model.findMany(options);
            return res(ctx.json(records));
        })),
        msw_1.rest.get(buildUrl(modelPath + "/:" + primaryKey), withErrors(function (req, res, ctx) {
            var _a;
            var id = req.params[primaryKey];
            var where = (_a = {},
                _a[primaryKey] = {
                    equals: id
                },
                _a);
            var entity = model.findFirst({
                strict: true,
                where: where
            });
            return res(ctx.json(entity));
        })),
        msw_1.rest.post(buildUrl(modelPath), withErrors(function (req, res, ctx) {
            var createdEntity = model.create(req.body);
            return res(ctx.status(201), ctx.json(createdEntity));
        })),
        msw_1.rest.put(buildUrl(modelPath + "/:" + primaryKey), withErrors(function (req, res, ctx) {
            var _a;
            var id = req.params[primaryKey];
            var where = (_a = {},
                _a[primaryKey] = {
                    equals: id
                },
                _a);
            var updatedEntity = model.update({
                strict: true,
                where: where,
                data: req.body
            });
            return res(ctx.json(updatedEntity));
        })),
        msw_1.rest["delete"](buildUrl(modelPath + "/:" + primaryKey), withErrors(function (req, res, ctx) {
            var _a;
            var id = req.params[primaryKey];
            var where = (_a = {},
                _a[primaryKey] = {
                    equals: id
                },
                _a);
            var deletedEntity = model["delete"]({
                strict: true,
                where: where
            });
            return res(ctx.json(deletedEntity));
        })),
    ];
}
exports.generateRestHandlers = generateRestHandlers;
